module.exports = __webpack_public_path__ + "static/media/dermatologia.e3aa1674.png";